<template>
<div>
  <div class="bg-white p-3 rounded shadow">
    <div class="sticky-top">
      <nav class="navbar bg-dark navbar-expand-lg shadow">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <img width="35px" class="mr-2" src="@/assets/logo.png"> <h2 class="text-white pr-5 mr-5">R&egrave;sum&egrave; Wizard</h2>
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link text-white" href="#!" @click.prevent="togglePreview()" @click="loadHelpSection('preview')"><i class="fas fa-print"></i> Print Preview</a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" data-toggle="modal" data-target="#upload" href="#!"><i class="fas fa-file-upload"></i> Load Previously Saved R&egrave;sum&egrave;</a>
            </li>
            <li class="nav-item">
              <a @click="resumeExport()" class="nav-link text-white" href="#!"><i class="fas fa-save"></i> Save R&egrave;sum&egrave;</a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" href="#!" data-toggle="modal" data-target="#clearConfirm"><i class="fas fa-trash-alt"></i> Clear</a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" href="#!" @click.prevent="loadHelpSection('')"><i class="fas fa-info-circle"></i> Help</a>
            </li>
          </ul>
        </div>
      </nav>
      <div class="alert alert-primary alert-dismissible fade show text-center" role="alert">
        <i class="fas fa-info-circle"></i> Save your progress before leaving this page. Information will automatically be saved when typed into the form.
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="card mb-3 mt-3 text-left" @click="loadHelpSection('heading')">
      <div class="card-body">
        <h3 class="card-title p-1 p-1"><i class="fas fa-caret-right"></i> R&egrave;sum&egrave; Heading</h3>
        <p class="lead">At least one of the following fields is required: Primary Phone Number, Email Address, or Mailing Address</p>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="fullName">Full Name <small class="text-secondary">(required)</small></label>
              <input type="text" @select="loadHelpSection('heading')" v-model="form.fullName" @input="storeData('fullName', form.fullName)" class="form-control" id="fullName" name="fullName" required>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="telephone">Primary Phone Number *</label>
              <input type="text" @select="loadHelpSection('heading')" @change="formatPhoneNumber()" v-model="form.phone" @input="storeData('phone', form.phone)" class="form-control" id="telephone" name="telephone" required>
              <div v-if="phoneError" class="text-danger">
                <i class="fas fa-exclamation-circle"></i> Invalid format. Example (123) 456-7890
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="email">Email Address *</label>
              <input type="text" @select="loadHelpSection('heading')" @change="validateEmail()" v-model="form.email" @input="storeData('email', form.email)" class="form-control" id="email" name="email" required>
              <div v-if="emailError" class="text-danger">
                <i class="fas fa-exclamation-circle"></i> Invalid format. Example name@email.com
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="secondaryTelephone">Secondary Phone Number<small class='text-secondary'> (optional)</small></label>
              <input type="text" @select="loadHelpSection('heading')" @change="formatSecondaryPhone()" v-model="form.secondaryPhone" @input="storeData('secondaryPhone', form.secondaryPhone)" class="form-control" id="secondaryTelephone" name="secondaryTelephone">
              <div v-if="secondaryPhoneError" class="text-danger">
                <i class="fas fa-exclamation-circle"></i> Invalid format. Example (123) 456-7890
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="fax">Fax <small class='text-secondary'> (optional)</small></label>
              <input type="text" @select="loadHelpSection('heading')" @change="formatFax()" v-model="form.fax" @input="storeData('fax', form.fax)" class="form-control" id="fax" name="fax">
              <div v-if="faxError" class="text-danger">
                <i class="fas fa-exclamation-circle"></i> Invalid format. Example (123) 456-7890
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr></div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="streetAddress">Street Address *</label><br>
              <input type="text" @select="loadHelpSection('heading')" v-model="form.streetAddress" @input="storeData('streetAddress', form.streetAddress)" class="form-control" id="streetAddress" name="streetAddress"
                placeholder="123 Street Name" required>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="city">City *</label><br>
              <input type="text" @select="loadHelpSection('heading')" v-model="form.city" @input="storeData('city', form.city)" class="form-control" id="city" name="city" required>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="state">State *</label><br>
              <select v-model="form.state" @select="loadHelpSection('heading')" @change="storeData('state', form.state)" class="form-control" id="state" name="state" required>
                <option value=""></option>
                <option value="AL">Alabama (AL)</option>
                <option value="AK">Alaska (AK)</option>
                <option value="AZ">Arizona (AZ)</option>
                <option value="AR">Arkansas (AR)</option>
                <option value="CA">California (CA)</option>
                <option value="CO">Colorado (CO)</option>
                <option value="CT">Connecticut (CT)</option>
                <option value="DE">Delaware (DE)</option>
                <option value="DC">District Of Columbia (DC)</option>
                <option value="FL">Florida (FL)</option>
                <option value="GA">Georgia (GA)</option>
                <option value="HI">Hawaii (HI)</option>
                <option value="ID">Idaho (ID)</option>
                <option value="IL">Illinois (IL)</option>
                <option value="IN">Indiana (IN)</option>
                <option value="IA">Iowa (IA)</option>
                <option value="KS">Kansas (KS)</option>
                <option value="KY">Kentucky (KY)</option>
                <option value="LA">Louisiana (LA)</option>
                <option value="ME">Maine (ME)</option>
                <option value="MD">Maryland (MD)</option>
                <option value="MA">Massachusetts (MA)</option>
                <option value="MI">Michigan (MI)</option>
                <option value="MN">Minnesota (MN)</option>
                <option value="MS">Mississippi (MS)</option>
                <option value="MO">Missouri (MO)</option>
                <option value="MT">Montana (MT)</option>
                <option value="NE">Nebraska (NE)</option>
                <option value="NV">Nevada (NV)</option>
                <option value="NH">New Hampshire (NH)</option>
                <option value="NJ">New Jersey (NJ)</option>
                <option value="NM">New Mexico (NM)</option>
                <option value="NY">New York (NY)</option>
                <option value="NC">North Carolina (NC)</option>
                <option value="ND">North Dakota (ND)</option>
                <option value="OH">Ohio (OH)</option>
                <option value="OK">Oklahoma (OK)</option>
                <option value="OR">Oregon (OR)</option>
                <option value="PA">Pennsylvania (PA)</option>
                <option value="RI">Rhode Island (RI)</option>
                <option value="SC">South Carolina (SC)</option>
                <option value="SD">South Dakota (SD)</option>
                <option value="TN">Tennessee (TN)</option>
                <option value="TX">Texas (TX)</option>
                <option value="UT">Utah (UT)</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="zip">ZIP Code *</label><br>
              <input type="text" @select="loadHelpSection('heading')" @change="validateZip()" v-model="form.zip" @input="storeData('zip', form.zip)" class="form-control" id="zip" name="zip" required>
              <div v-if="zipError" class="text-danger">
                <i class="fas fa-exclamation-circle"></i> Invalid format. Example 12345
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-3" @click="loadHelpSection('objective')">
      <div class="card-body">
        <label for="objective"><h3 class="card-title p-1"><i class="fas fa-caret-right"></i> Objective</h3></label>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <div class="float-right" v-if="objectiveWordCount < 41">Word Count: {{ objectiveWordCount }}</div>
              <div class="float-right text-danger" v-else>Word Count: {{ objectiveWordCount }}</div>
              <div v-if="objectiveWordCount > 40" class="text-primary float-left"><i class="fas fa-info-circle"></i> It's recommended to keep the objective to 40 words or less.</div>
              <textarea @select="loadHelpSection('objective')" v-model="form.objective" @update="wordCountObjective()" @input="storeData('objective', form.objective); wordCountObjective()" class="form-control" id="objective" name="objective" required></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3" @click="loadHelpSection('skills')">
      <div class="card-body">
        <h3 class="card-title p-1"><i class="fas fa-caret-right"></i> Skills <small class="text-secondary">(Required Section)</small></h3>
        <div class="row ">
          <div class="col-5">
            <div v-if="form.skills.length <= skillsLimit">
              <p>Please list your skills using the following input field. Submit skills individually.</p>
              <div class="input-group mb-3 shadow">
                <input type="text" @select="loadHelpSection('skills')" v-model="newSkill" class="form-control" placeholder="" aria-label="">
                <div class="input-group-append">
                  <button class="btn btn-primary" @click="addSkill();" type="button" id="button-addon2"><i class="fas fa-plus-circle"></i> Add Skill</button>
                </div>
              </div>
              <div v-if="skillError" class="alert alert-warning text-center" role="alert">
                  This skill already exists.
              </div>
            </div>
            <label for="skillsNotes">Additional Notes</label>
              <div class="float-right" v-if="skillsNotesWordCount < 41">Word Count: {{ skillsNotesWordCount }}</div>
              <div class="float-right text-danger" v-else>Word Count: {{ skillsNotesWordCount }}</div>
              <div v-if="skillsNotesWordCount > 40" class="text-primary float-left"><i class="fas fa-info-circle"></i> It's recommended to keep notes to 40 words or less.</div>
            <div class="input-group">
              <textarea class="form-control" id="skillsNotes" v-model="form.skillsNotes" @input="storeData('skillsNotes', form.skillsNotes); wordCountSkillsNotes()" name="skillsNotes"></textarea>
            </div>
          </div>
          <div class="col-7">
            <div class="row">
              <div class="col-12 mb-2" v-if="form.skills.length > 0">Click on an item to edit</div>
              <ul class="list-group" v-for="(skill, n) in form.skills" :key="skill.id">
                  <li class="list-group-item mb-3 mr-3"><span style="cursor:pointer;" data-toggle="modal" data-target="#editSkill" @click.prevent="loadSkills(n)">{{ skill.value }}</span> <a class="text-danger pl-2" href="#!" @select="loadHelpSection('skills')" @click.prevent="removeSkill(n)"><i class="fas fa-trash-alt"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3" @click="loadHelpSection('history')">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <h3 class="card-title p-1"><i class="fas fa-caret-right"></i> Employment History <small class="text-secondary">(Required Section)</small></h3>
          </div>
          <div class="row">
            <div class="col-5"  v-if="form.employeers.length <= this.employeerLimit">
              <div class="card shadow">
                <div class="card-body">
                  <employmentHistory @loadHelpSection="loadHelpSection('history')" @storeData="storeEmployment($event)" />
                </div>
              </div>
            </div>
            <div v-if="form.employeers.length > 0" class="col-7">
              <div class="row" v-for="(employeer, n) in form.employeers" :employeer="employeer = JSON.parse(employeer.value)" :key="employeer.id">
                <div class="col-12">
                  <div class="card m-1 p-1">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-4 lead">{{ employeer.jobTitle }}</div>
                        <div class="col-3">{{ employeer.companyName }}</div>
                        <div class="col-2">{{ employeer.companyLocation }} </div>
                        <div class="col-3"><a class="float-right" href="" @select="loadHelpSection('history')" @click.prevent="removeEmployment(n)"><i class="far fa-trash-alt text-danger"></i></a> {{ employeer.companyStartDate }} - {{ employeer.companyEndDate }}</div>
                        <div class="col-12">
                          {{ employeer.jobDuties }}
                        </div>
                        <div class="col-12 pt-2" v-if="employeer.jobAccomplishments.length > 0">
                          <i class="pr-3">Accomplishment<span v-if="employeer.jobAccomplishments.length > 1">s</span>:</i>
                          <span v-for="(accomplishment, index) in employeer.jobAccomplishments" :key="accomplishment.id"><span v-if="index !== 0">, </span>{{ accomplishment.value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-7 lead text-dark pt-4">
              <i class="far fa-hand-point-left"></i> Please add your employment history
            </div>
          </div>
        </div>
      </div>
    </div>

      <div v-if="!militaryService" class="text-center">
        <a href="" @click.prevent="militaryService=true" class="btn btn-lg btn-danger mb-3 float-center"><i class="fas fa-flag"></i> Add Military Service Section</a>
      </div>

      <div v-else class="card mb-3" @click="loadHelpSection('military')">
        <div class="card-body">
          <div class="row">
            <div class="col-6"><h3 class="card-title p-1"><i class="fas fa-caret-right"></i> Military Service</h3></div>
            <div class="col-6 text-right"><a href="#!" @select="loadHelpSection('military')" data-toggle="modal" data-target="#militaryConfirm" class="btn btn-secondary">Remove Military Service Section</a></div>
            <div class="col-5"  v-if="form.military.length <= this.militaryLimit">
              <div class="card shadow">
                <div class="card-body">
                  <militaryHistory @loadHelpSection="loadHelpSection('military')" @storeData="storeMilitary($event)" />
                </div>
              </div>
            </div>
            <div v-if="form.military.length > 0" class="col-7">
              <div class="row" v-for="(service, n) in form.military" :service="service = JSON.parse(service.value)" :key="service.id">
                <div class="col-12">
                  <div class="card m-1 p-1">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-5 lead">{{ service.branch }}</div>
                        <div class="col-4">{{ service.serviceStartDate }} - {{ service.serviceEndDate }}</div>
                        <div class="col-3"><a class="float-right" href="" @select="loadHelpSection('military')" @click.prevent="removeMilitary(n)"><i class="far fa-trash-alt text-danger"></i></a> {{ service.rank }}</div>
                        <div class="col-12">
                          {{ service.duties }}
                        </div>
                        <div class="col-12 pt-2" v-if="service.accomplishments.length > 0">
                          <i class="pr-3">Accomplishment<span v-if="service.accomplishments.length > 1">s</span>:</i>
                          <span v-for="(accomplishment, index) in service.accomplishments" :key="accomplishment.id"><span v-if="index !== 0">, </span>{{ accomplishment.value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-7 lead text-dark pt-4">
              <i class="far fa-hand-point-left"></i> Please add your military service history
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3" @click="loadHelpSection('education')">
        <div class="card-body">
          <h3 class="card-title p-1"><i class="fas fa-caret-right"></i> Education</h3>
          <div class="row">
            <div class="col-5" v-if="form.education.length <= this.educationLimit">
              <div class="card shadow">
                <div class="card-body">
                  <educationHistory @loadHelpSection="loadHelpSection('education')" @storeData="storeEducation($event)" />
                </div>
              </div>
            </div>
            <div v-if="form.education.length > 0" class="col-7">
              <div class="row  pb-3" v-for="(school, n) in form.education" :school="school = JSON.parse(school.value)" :key="school.id">
                <div class="col-12">
                  <div class="card m-1 p-1">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">{{ school.name }}</div>
                        <div class="col"><span v-if="school.date_accomplished">{{ school.date_accomplished }}<br></span>{{ school.degree }}</div>
                        <div class="col-3">{{ school.date }} </div>
                        <div class="col-2"><a class="float-right" href="" @select="loadHelpSection('education')" @click.prevent="removeEducation(n)"><i class="far fa-trash-alt text-danger"></i></a> <span v-if="school.gpa">{{ school.gpa }} GPA</span></div>
                        <div class="col-12" v-if="school.honors">
                          <p><i class="pr-3">Academic Honors:</i> {{ school.honors }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-7 lead text-dark pt-4">
              <i class="far fa-hand-point-left"></i> Please add your edcuation history
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3" @click="loadHelpSection('certs')">
        <div class="card-body">
          <h3 class="card-title p-1"><i class="fas fa-caret-right"></i> Certifications & Licenses</h3>
          <div class="row ">
            <div class="col-5">
              <div v-if="form.certificates.length <= certificatesLimit">
                <div class="input-group mb-3 shadow">
                  <input type="text" @select="loadHelpSection('certs')" v-model="newCertificate" class="form-control" placeholder="Project Management Professional (PMP) 2019" aria-label="" >
                  <div class="input-group-append">
                    <button class="btn btn-primary" @click="addCertificate();" type="button" id="button-addon2"><i class="fas fa-plus-circle"></i> Add</button>
                  </div>
                </div>
                <div v-if="certificateError" class="alert alert-warning text-center" role="alert">
                  This item already exists.
                </div>
              </div>
              <label for="certificatesNotes">Additional Notes</label>
              <div class="float-right" v-if="certificatesNotesWordCount < 41">Word Count: {{ certificatesNotesWordCount }}</div>
              <div class="float-right text-danger" v-else>Word Count: {{ certificatesNotesWordCount }}</div>
              <div v-if="certificatesNotesWordCount > 40" class="text-primary float-left"><i class="fas fa-info-circle"></i> It's recommended to keep this field to 40 words or less.</div>
              <div class="input-group">
                <textarea class="form-control" id="certificatesNotes" v-model="form.certificatesNotes" @input="storeData('certificatesNotes', form.certificatesNotes); wordCountCertNotes()" name="certificatesNotes"></textarea>
              </div>
            </div>
            <div class="col-7">
              <div class="row">
                <div class="col-12 mb-2" v-if="form.certificates.length > 0">Click on an item to edit</div>
                <ul class="list-group" v-for="(cert, n) in form.certificates" :key="cert.id">
                    <li class="list-group-item mb-3 mr-3"><span style="cursor:pointer;" data-toggle="modal" data-target="#editCert" @click.prevent="loadCert(n)">{{ cert.value }}</span> <a class="text-danger pl-2" href="#!" @select="loadHelpSection('skills')" @click.prevent="removeCertificate(n)"><i class="fas fa-trash-alt"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="clearConfirm" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Clear Data Confirmation</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Are you sure you want to clear the data from the form?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click.prevent="clearStoredData()" type="button" class="btn btn-primary">Yes, clear the form</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="militaryConfirm" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Clear Military Entries Confirmation</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Are you sure you want to clear military records?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click.prevent="removeMilitaryService()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">Yes, clear military records</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="editSkill" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Skill</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label for="skillEdit">Value</label>
              <input id="skillEdit" class="form-control" type="text" v-model="editSkillValue">
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
              <button @click.prevent="updateSkill()" type="button" class="btn btn-success" data-dismiss="modal" aria-label="Close">Save</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="editCert" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Certificate/License</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label for="certEdit">Value</label>
              <input id="certEdit" class="form-control" type="text" v-model="editCertValue">
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
              <button @click.prevent="updateCert()" type="button" class="btn btn-success" data-dismiss="modal" aria-label="Close">Save</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="upload" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">UpLoad Previously Saved R&egrave;sum&egrave; File</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
              </div>
              <div class="modal-body">
              <input type="file" id="file" ref="file" />
              </div>
              <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal" @click="loadFile">Use File</button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import employmentHistory from './form/employmentHistory.vue';
import educationHistory from './form/educationHistory.vue';
import militaryHistory from './form/militaryHistory.vue';

export default {
  name: 'resume',
  components: {
    employmentHistory,
    educationHistory,
    militaryHistory,
  },
  props: ['version'],
  data() {
    return {
      sectionHelp: '',
      skillsLimit: 11,
      newSkill: '',
      editSkillValue: '',
      editSkillPosition: '',
      editCertValue: '',
      editCertPosition: '',
      certificatesLimit: 5,
      newCertificate: '',
      education: [],
      employeerLimit: 4,
      militaryLimit: 4,
      educationLimit: 4,
      newEmployeer: '',
      employeerId: '',
      skillError: false,
      certificateError: false,
      phoneError: false,
      emailError: false,
      secondaryPhoneError: false,
      faxError: false,
      zipError: false,
      militaryService: false,
      objectiveWordCount: 0,
      skillsNotesWordCount: 0,
      certificatesNotesWordCount: 0,
      honorsWordCount: 0,
      certNotesWordCount: 0,
      file: '',
      password: 'resumewizard',
      form: {
        fullName: '',
        phone: '',
        email: '',
        secondaryPhone: '',
        fax: '',
        streetAddress: '',
        city: '',
        state: '',
        zip: '',
        objective: '',
        skills: [],
        skillsNotes: "",
        employeers: [],
        military: [],
        education: [],
        certificates: [],
        certificatesNotes: "",
        dateExported: new Date(),
        resumeVersion: '20.4.0 Alpha',
        applicationVersion: this.version,
      }
    }
  },
  methods: {
    formatPhoneNumber() {
      var phoneNumber = this.form.phone.replace(/[^\d]/g, "");
      var corrected = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

      if (phoneNumber.length == 10) {
        this.form.phone = corrected;
        this.storeData("phone", corrected);
        this.phoneError = false;
      } else {
        this.phoneError = true;
      }

    },

    formatSecondaryPhone() {
      var phoneNumber = this.form.secondaryPhone.replace(/[^\d]/g, "");

      if (phoneNumber.length == 10) {
        var corrected = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.form.secondaryPhone = corrected;
        this.storeData("secondaryPhone", corrected);
        this.secondaryPhoneError = false;
      } else {
        this.secondaryPhoneError = true;
      }
    },

    formatFax() {
      var phoneNumber = this.form.fax.replace(/[^\d]/g, "");

      if (phoneNumber.length == 10) {
        var corrected = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.form.fax = corrected;
        this.storeData("fax", corrected);
        this.faxError = false;
      } else {
        this.faxError = true;
      }
    },

    validateEmail() {
      var email = this.form.email;
      var corrected = /\S+@\S+\.\S+/;
      if (corrected.test(email)) {
        this.form.email = email;
        this.storeData("email", email);
        this.emailError = false;
      } else {
        this.emailError = true;
      }
    },

    validateZip() {
      var zip = this.form.zip;
      var corrected = /^\d{5}(?:[-\s]\d{4})?$/;
      if (corrected.test(zip)) {
        this.form.zip = zip;
        this.storeData("zip", zip);
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },

    addSkill() {
      // ensure they actually typed something
      if (!this.newSkill) {
        return;
      }
      
      var skill_values = []
      var skill;
      for(skill in this.form.skills) {
        var value = this.form.skills[skill].value;
        skill_values.push(value);
      }

      var search = skill_values.indexOf(this.newSkill);
      
      if(search == -1)
      {
        this.form.skills.push({id: Math.round((Math.random() * 1000000)), value: this.newSkill});
        this.newSkill = '';
        this.storeSkills();
        this.skillError = false;
      } else {
        this.skillError = true;
      }
    },

    removeSkill(x) {
      this.form.skills.splice(x, 1);
      this.storeSkills();
    },

    storeSkills() {
      var json = JSON.stringify(this.form.skills);
      localStorage.setItem('skills', json);
    },

    loadSkills(x) {
      this.editSkillValue = this.form.skills[x].value;
      this.editSkillPosition = x;
    },

    updateSkill() {
      this.form.skills[this.editSkillPosition].value = this.editSkillValue;
    },

    addCertificate() {
      if (!this.newCertificate) {
        return;
      }

      var cert_values = []
      var cert;
      for(cert in this.form.certificates) {
        var value = this.form.certificates[cert].value;
        cert_values.push(value);
      }

      var search = cert_values.indexOf(this.newCertificate);

      if(search == -1)
      {
        this.form.certificates.push({id: Math.round((Math.random() * 1000000)), value: this.newCertificate});
        this.newCertificate = '';
        this.storeCertificates();
        this.certificateError = false;
      } else {
        this.certificateError = true;
      }
    },

    removeCertificate(x) {
      this.form.certificates.splice(x, 1);
      this.storeCertificates();
    },

    storeCertificates() {
      var json = JSON.stringify(this.form.certificates);
      localStorage.setItem('certificates', json);
    },

    loadCert(x) {
      this.editCertValue = this.form.certificates[x].value;
      this.editCertPosition = x;
    },

    updateCert() {
      this.form.certificates[this.editCertPosition].value = this.editCertValue;
    },

    removeEmployment(n) {
      this.form.employeers.splice(n, 1);
      var employeersJson = JSON.stringify(this.form.employeers);
      localStorage.setItem('employment', employeersJson);
    },

    removeEducation(n) {
      this.form.education.splice(n, 1);
      var educationJson = JSON.stringify(this.form.education);
      localStorage.setItem('education', educationJson);
    },

    removeMilitary(n) {
      this.form.military.splice(n, 1);
      var militaryJson = JSON.stringify(this.form.military);
      localStorage.setItem('military', militaryJson);
    },

    removeMilitaryService() {
      this.form.military = [];
      var militaryJson = JSON.stringify(this.form.military);
      localStorage.setItem('military', militaryJson)
      this.militaryService = false;
    },

    loadHelpSection(sectionName) {
      this.$emit('setHelpSection', sectionName);
    },

    resumeExport() {
      this.$emit('resumeExport', this.encryptCodes(this.form))
    },

    togglePreview() {
      this.$emit('preview', this.form)
    },

    storeData(fieldName, fieldValue) {
      localStorage.setItem(fieldName, fieldValue);
    },

    storeEmployment(e) {
      var json = JSON.stringify(e);
      this.form.employeers.push({"id": Math.round(Math.random() * 1000000), "value":json});
      var employeersJson = JSON.stringify(this.form.employeers);
      localStorage.setItem('employment', employeersJson);
    },

    storeEducation(e) {
      var json = JSON.stringify(e);
      this.form.education.push({"id": Math.round(Math.random() * 1000000), "value":json});
      var educationJson = JSON.stringify(this.form.education);
      localStorage.setItem('education', educationJson);
    },

    storeMilitary(e) {
      var json = JSON.stringify(e);
      this.form.military.push({"id": Math.round(Math.random() * 1000000), "value":json});
      var militaryJson = JSON.stringify(this.form.military);
      localStorage.setItem('military', militaryJson);
    },

    clearStoredData() {
      localStorage.clear();
      this.form = {};
      location.reload();
    },

    // Word Count Functions
    wordCountObjective() {
      this.form.objective = this.form.objective.replace(/[\n\r]/g, '');
      var count = this.form.objective.trim().split(" ").length;
      this.objectiveWordCount = count;
    },

    wordCountSkillsNotes() {
      this.form.skillsNotes = this.form.skillsNotes.replace(/[\n\r]/g, '');
      var count = this.form.skillsNotes.trim().split(" ").length;
      this.skillsNotesWordCount = count;
    },

    wordCountCertNotes() {
      var count = this.form.certificatesNotes.trim().split(" ").length;
      this.certificatesNotesWordCount = count;
    },

    // Basic Encryption
    encryptCodes: function(c) {
        var content = JSON.stringify(c);
        var passcode = this.password
        var result = []; var passLen = passcode.length ;
        for(var i = 0  ; i < content.length ; i++) {
            var passOffset = i%passLen ;
            var calAscii = (content.charCodeAt(i)+passcode.charCodeAt(passOffset));
            result.push(calAscii);
        }
        return JSON.stringify(result) ;
    },

    encryptCodesNo: function(c) {
      return c;
    },

    // Decryption
    decryptCodes: function(c) {
        var content = c
        var passcode = this.password
        var result = [];var str = '';
        var codesArr = JSON.parse(content);var passLen = passcode.length ;
        for(i = 0  ; i < codesArr.length ; i++) {
            var passOffset = i%passLen ;
            var calAscii = (codesArr[i]-passcode.charCodeAt(passOffset));
            result.push(calAscii) ;
        }
        for(var i = 0 ; i < result.length ; i++) {
            var ch = String.fromCharCode(result[i]); str += ch ;
        }
        return str ;
    },

    //Load JSON file
    loadFile() {
      //Evaluate selected file
      let file = this.$refs.file.files[0];

      //Check if JSON file type
      if (!file || file.type !== 'application/json') {
        this.file = null;
        return
      }

      //Read contents of the file
      let reader = new FileReader();
      reader.readAsText(file, "UTF-8");
      reader.onload = evt => {
        var content = evt.target.result;
        //Parse file for JSON and load JSON object to the file variable.
        this.file = JSON.parse(content);
        this.loadFields();
      }

      reader.onerror = evt => {
        this.file = null;
        console.error(evt);
      }
    },

    loadFields() {
      var decryptedData = JSON.parse(this.decryptCodes(this.file.resumeData));

      this.form.fullName = decryptedData.fullName;
      this.storeData("fullName", this.form.fullName);

      this.form.phone = decryptedData.phone;
      this.storeData("phone", this.form.phone);

      this.form.email = decryptedData.email;
      this.storeData("email", this.form.email);

      this.form.secondaryPhone = decryptedData.secondaryPhone;
      this.storeData("secondaryPhone", this.form.secondaryPhone);

      this.form.fax = decryptedData.fax;
      this.storeData("fax", this.form.fax);

      this.form.streetAddress = decryptedData.streetAddress;
      this.storeData("streetAddress", this.form.streetAddress);

      this.form.city = decryptedData.city;
      this.storeData("city", this.form.city);

      this.form.state = decryptedData.state;
      this.storeData("state", this.form.state);

      this.form.zip = decryptedData.zip;
      this.storeData("zip", this.form.zip);

      this.form.objective = decryptedData.objective;
      this.storeData("objective", this.form.objective);

      this.form.objective = decryptedData.objective;
      this.storeData("objective", this.form.objective);

      this.form.skills = JSON.stringify(decryptedData.skills);
      this.storeData("skills", this.form.skills);

      this.form.skillsNotes = decryptedData.skillsNotes;
      this.storeData("skillsNotes", this.form.skillsNotes);

      this.form.employeers = JSON.stringify(decryptedData.employeers);
      localStorage.setItem('employment', this.form.employeers);

      this.form.military = JSON.stringify(decryptedData.military);
      localStorage.setItem('military', this.form.military);

      this.form.education = decryptedData.education;
      localStorage.setItem('education', JSON.stringify(this.form.education));

      this.form.certificates = JSON.stringify(decryptedData.certificates);
      this.storeData("certificates", this.form.certificates);

      this.form.certificatesNotes = decryptedData.certificatesNotes;
      this.storeData("certificatesNotes", this.form.certificatesNotes);

      location.reload();
    }
  },
  mounted() {
    // Check for local storage. If they exists populate the form data fields.
    if (localStorage.fullName) {
      this.form.fullName = localStorage.fullName;
    }

    if (localStorage.phone) {
      this.form.phone = localStorage.phone;
    }

    if (localStorage.email) {
      this.form.email = localStorage.email;
    }

    if (localStorage.secondaryPhone) {
      this.form.secondaryPhone = localStorage.secondaryPhone;
    }

    if (localStorage.fax) {
      this.form.fax = localStorage.fax;
    }

    if (localStorage.streetAddress) {
      this.form.streetAddress = localStorage.streetAddress;
    }

    if (localStorage.city) {
      this.form.city = localStorage.city;
    }

    if (localStorage.state) {
      this.form.state = localStorage.state;
    }

    if (localStorage.zip) {
      this.form.zip = localStorage.zip;
    }

    if (localStorage.objective) {
      this.form.objective = localStorage.objective;
      this.wordCountObjective();
    }

    if(localStorage.skills) {
      this.form.skills = JSON.parse(localStorage.skills);
    }

    if(localStorage.skillsNotes) {
      this.form.skillsNotes = localStorage.skillsNotes;
      this.wordCountSkillsNotes();
    }

    if (localStorage.employment) {
      this.form.employeers = JSON.parse(localStorage.employment);
    }

    if(localStorage.military) {
      this.form.military = JSON.parse(localStorage.military);
      this.militaryService = true;
    }

    if(localStorage.education) {
      this.form.education = JSON.parse(localStorage.education);
    }

    if(localStorage.certificates) {
      this.form.certificates = JSON.parse(localStorage.certificates);
    }

    if(localStorage.certificatesNotes) {
      this.form.certificatesNotes = localStorage.certificatesNotes;
      this.wordCountCertNotes();
    }

  }
}
</script>

<style scope>
.navbar {
  background-color: #252525;
}
</style>
